import React, { PropTypes } from 'react';
import { IntlProvider } from 'react-intl';

const IntlWrapper = ({ messages, locale = 'en', children }) =>
  <IntlProvider messages={messages} locale={locale}>{children}</IntlProvider>;

IntlWrapper.propTypes = {
  messages: PropTypes.objectOf(PropTypes.string),
  locale: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};
export default IntlWrapper;




// WEBPACK FOOTER //
// ./app/containers/IntlWrapper.jsx